'use client';
import { CreateDiscussionQuestionDialog } from '@/components/create-discussion-question-dialog';
import RegisterDialog from '@/components/RegisterDialog';
import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/store';
import { useState } from 'react';

export default function StartDiscussionComponent() {
  const [
    showCreateDiscussionQuestionDialog,
    setShowCreateDiscussionQuestionDialog,
  ] = useState(false);

  const user = useAuthStore((state) => state.user);

  const handleStartDiscussion = () => {
    setShowCreateDiscussionQuestionDialog(true);
  };

  return (
    <>
      {user ? (
        <Button
          variant="outline"
          className="font-bold  uppercase"
          onClick={handleStartDiscussion}
        >
          Start a Discussion
        </Button>
      ) : (
        <RegisterDialog
          title="Join the Discussion. Your Insight Matters."
          description="Sign up to ask a question, share a story, or weigh in on workplace innovation and change. Be part of a growing community solving real challenges together."
        >
          <Button variant="outline" className="font-bold  uppercase">
            Start a Discussion
          </Button>
        </RegisterDialog>
      )}
      {showCreateDiscussionQuestionDialog && (
        <CreateDiscussionQuestionDialog
          open={showCreateDiscussionQuestionDialog}
          onOpenChange={setShowCreateDiscussionQuestionDialog}
        />
      )}
    </>
  );
}
